"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m1 11-1-2H9.5v5H8V7h6l1 2h3v6z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "m15 9-1-2H8v11h1.5v-5H12l1 2h5V9zm1.5 4.5h-2.57l-1-2H9.5v-3h3.57l1 2h2.43z"
}, "2")], 'FlagCircleTwoTone');